// Meta Pixel ID
const PIXEL_ID = '1198080871245425'

// Declare fbq as global
declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fbq: any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _fbq: any
  }
}

// Initialize Meta Pixel
export function initPixel(): void {
  if (typeof window === 'undefined') return
  if (window.fbq) return // already initialized

  // Inject the fbevents.js script
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  // Set up the fbq stub
  const fbq = function (...args: unknown[]) {
    fbq.callMethod ? fbq.callMethod(...args) : fbq.queue.push(args)
  } as Window['fbq']

  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = []

  window.fbq = fbq
  window._fbq = fbq

  window.fbq('init', PIXEL_ID)
}

// Track PageView
export function trackPageView(): void {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', 'PageView')
}

// Track AddToCart
export function trackAddToCart(): void {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', 'AddToCart', {
    content_name: 'El Apoyo Incondicional',
    content_ids: ['45555442090182'],
    content_type: 'product',
    value: 7.77,
    currency: 'USD',
  })
}
